/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationGroupType } from './OrganizationGroupType';
import {
    OrganizationGroupTypeFromJSON,
    OrganizationGroupTypeFromJSONTyped,
    OrganizationGroupTypeToJSON,
    OrganizationGroupTypeToJSONTyped,
} from './OrganizationGroupType';
import type { UserOrganizationResponse } from './UserOrganizationResponse';
import {
    UserOrganizationResponseFromJSON,
    UserOrganizationResponseFromJSONTyped,
    UserOrganizationResponseToJSON,
    UserOrganizationResponseToJSONTyped,
} from './UserOrganizationResponse';

/**
 * 
 * @export
 * @interface UserOrganizationGroupResponse
 */
export interface UserOrganizationGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof UserOrganizationGroupResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOrganizationGroupResponse
     */
    name?: string | null;
    /**
     * 
     * @type {any}
     * @memberof UserOrganizationGroupResponse
     */
    organizationGroupId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof UserOrganizationGroupResponse
     */
    shortName?: string | null;
    /**
     * 
     * @type {OrganizationGroupType}
     * @memberof UserOrganizationGroupResponse
     */
    organizationGroupType?: OrganizationGroupType;
    /**
     * 
     * @type {Array<UserOrganizationResponse>}
     * @memberof UserOrganizationGroupResponse
     */
    organizations?: Array<UserOrganizationResponse> | null;
}



/**
 * Check if a given object implements the UserOrganizationGroupResponse interface.
 */
export function instanceOfUserOrganizationGroupResponse(value: object): value is UserOrganizationGroupResponse {
    return true;
}

export function UserOrganizationGroupResponseFromJSON(json: any): UserOrganizationGroupResponse {
    return UserOrganizationGroupResponseFromJSONTyped(json, false);
}

export function UserOrganizationGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserOrganizationGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'organizationGroupId': json['organizationGroupId'] === undefined ? undefined : json['organizationGroupId'] === null ? null : json['organizationGroupId'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'organizationGroupType': json['organizationGroupType'] == null ? undefined : OrganizationGroupTypeFromJSON(json['organizationGroupType']),
        'organizations': json['organizations'] === undefined ? undefined : json['organizations'] === null ? null : ((json['organizations'] as Array<any>).map(UserOrganizationResponseFromJSON)),
    };
}

export function UserOrganizationGroupResponseToJSON(json: any): UserOrganizationGroupResponse {
    return UserOrganizationGroupResponseToJSONTyped(json, false);
}

export function UserOrganizationGroupResponseToJSONTyped(value?: UserOrganizationGroupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'name': value['name'],
        'organizationGroupId': value['organizationGroupId'],
        'shortName': value['shortName'],
        'organizationGroupType': OrganizationGroupTypeToJSON(value['organizationGroupType']),
        'organizations': value['organizations'] == null ? undefined : ((value['organizations'] as Array<any>).map(UserOrganizationResponseToJSON)),
    };
}

